import { Injectable, inject, signal } from '@angular/core';

import { API_ROUTES } from '@utils/apiRoutes';
import { ApiService } from '@utils/apiService';
import {
  TransactionInfoResponse,
  TransactionDetail,
  ReceiptDownloadResponse,
  ReceiptEmailResponse,
  PaymentResponse,
  PaymentRequest,
  RedeemCodesRequest
} from '@app/schemas';

@Injectable({
  providedIn: 'root'
})
export class InfoTransactionService {
  private infoRequest = signal<TransactionDetail | Record<string, any> | null>(null);
  private apiService = inject(ApiService);

  getInfo(id: string) {
    return this.apiService.get<TransactionInfoResponse>(`${API_ROUTES.paymentProcess.routes.transaction}/${id}`);
  }

  createTransaction(body: PaymentRequest | RedeemCodesRequest | Record<string, any>) {
    return this.apiService.post<PaymentResponse>(`${API_ROUTES.paymentProcess.routes.pay}`, body);
  }

  setInfoRequest(values: TransactionDetail | Record<string, any> | null) {
    this.infoRequest.set(values);
  }

  getInfoRequest() {
    return this.infoRequest;
  }

  downloadPdf(idTransaction: string) {
    return this.apiService.get<ReceiptDownloadResponse>(`${API_ROUTES.paymentProcess.routes.sendPDF}/${idTransaction}?action=download`);
  }

  emailPdf(idTransaction: string) {
    return this.apiService.get<ReceiptEmailResponse>(`${API_ROUTES.paymentProcess.routes.sendPDF}/${idTransaction}?action=email`);
  }

  clearInfoRequest() {
    this.infoRequest.set({});
  }
}
